import React from 'react';
import {TimeRangeProvider, useTimeRange} from './TimeRangeContext';
import {ChartConfigProvider, useChartConfig} from './ChartConfigContext';
import {StatisticsUIProvider, useStatisticsUI} from './StatisticsUIContext';

export const StatisticsProvider = ({children, edgeId}) => {
  return (
    <TimeRangeProvider>
      <ChartConfigProvider edgeId={edgeId}>
        <StatisticsUIProvider>
          {children}
        </StatisticsUIProvider>
      </ChartConfigProvider>
    </TimeRangeProvider>
  );
};

// Backward-compatible aggregate hook.
// Prefer focused hooks to reduce re-renders.
export const useStatistics = () => ({
  ...useTimeRange(),
  ...useChartConfig(),
  ...useStatisticsUI(),
});

export const StatisticsContextProvider = ({children, edgeId: passedEdgeId}) => {
  return <StatisticsProvider edgeId={passedEdgeId}>{children}</StatisticsProvider>;
};

export {useTimeRange, useChartConfig, useStatisticsUI};
